import { JP_PREFECTURES } from "@/shared/constants/address";
import { BaseTextField } from "@/shared/ui/base-text-field";
import { Autocomplete, type TextFieldProps } from "@mui/material";
import React from "react";

export type PrefectureFieldProps = Pick<TextFieldProps, "size"> & {
  value: string | undefined;
  error?: boolean;
  helperText?: string;
  onChange: (value: string | "") => void;
};

export const PrefectureField = React.forwardRef<
  HTMLDivElement,
  PrefectureFieldProps
>((props, ref) => {
  const { onChange, helperText, error, ...rest } = props;
  return (
    <Autocomplete
      ref={ref}
      {...rest}
      value={props.value ?? null}
      options={JP_PREFECTURES}
      sx={{ minWidth: 180 }}
      renderInput={(params) => (
        <BaseTextField
          {...params}
          error={props.error}
          helperText={props.helperText}
        />
      )}
      onChange={(_, value) => {
        onChange(value ?? "");
      }}
    />
  );
});

PrefectureField.displayName = "PrefectureField";
